import axios from "axios";

import Config from "../../config";

// Exige sessao no backend (simpleVerifyToken) — ver o comentario em
// actionSalvarCredenciaisImoview.js sobre por que essas rotas nao podem ficar
// abertas e por que o header vai explicito em vez de vir do interceptor global.
const actionParearImoview = (usuarioId, data) => {
    const token = localStorage.getItem("token");

    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/usuarios/${usuarioId}/imoview-pareamento`,
        data,
        headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
};

export default actionParearImoview;
